module.exports = __webpack_public_path__ + "img/Logo-Reverse.4ba18ca1.png";